import { reactive } from 'vue';

export default {
  install(app) {
    // Create reactive RTL state
    const rtlState = reactive({
      isRTL: false
    });

    // RTL methods
    const rtlMethods = {
      getDocClasses() {
        return document.body.classList;
      },
      enableRTL() {
        rtlState.isRTL = true;
        this.getDocClasses().add('rtl');
        this.getDocClasses().add('menu-on-right');
        this.toggleBootstrapRTL(true);
      },
      disableRTL() {
        rtlState.isRTL = false;
        this.getDocClasses().remove('rtl');
        this.getDocClasses().remove('menu-on-right');
        this.toggleBootstrapRTL(false);
      },
      toggleBootstrapRTL(value) {
        for (let i = 0; i < document.styleSheets.length; i++) {
          let styleSheet = document.styleSheets[i];
          let { href } = styleSheet;
          if (href && href.endsWith('bootstrap-rtl.css')) {
            styleSheet.disabled = !value;
          }
        }
      }
    };

    // Create RTL object with state and methods
    const rtl = {
      ...rtlState,
      ...rtlMethods
    };

    // Make available globally via app.config.globalProperties
    app.config.globalProperties.$rtl = rtl;

    // Also provide it for composition API usage
    app.provide('rtl', rtl);
  }
}
